import React from 'react';
import {
  FormSelect,
  DomainObject,
  FormFieldProps,
  SelectProps,
} from '@eas/common-web';
import { useKsPublicSelectRenderFunction } from './hooks/ks-public-select-render-function';

export function KsPublicFormSelect<OPTION extends DomainObject>(
  props: FormFieldProps<SelectProps<OPTION>>
) {
  const renderFunction = useKsPublicSelectRenderFunction();

  return <FormSelect {...props} RenderFunction={renderFunction} />;
}
